import { RseObjectFit } from '@ramsys/stream-player-core';

export type RseVideoObjectFit = Extract<RseObjectFit, 'contain' | 'fill'>;

/** Shared mute / object-fit control state for any host of <rse-player>. */
export interface RsePlayerControlsState {
	muted: boolean;
	objectFit: RseVideoObjectFit;
}

export function createRsePlayerControls(
	overrides: Partial<RsePlayerControlsState> = {},
): RsePlayerControlsState {
	return {
		muted: true,
		objectFit: 'fill',
		...overrides,
	};
}

export function toggleRseMuted(state: RsePlayerControlsState, event?: Event): void {
	event?.stopPropagation();
	state.muted = !state.muted;
}

export function toggleRseObjectFit(state: RsePlayerControlsState, event?: Event): void {
	event?.stopPropagation();
	state.objectFit = state.objectFit === 'fill' ? 'contain' : 'fill';
}
